/**
 * Legal document upload validation schema.
 *
 * PRD-defined legal document type codes from:
 * `https://unify.health/fhir/cs/practice-legal-doc-type`
 */
import { z } from 'zod';

export const legalDocTypeCodes = [
  'articles-of-incorporation',
  'w9-form',
  'unify-contract',
  'general-liability-umbrella-policy',
  'epli',
] as const;

export type LegalDocTypeCode = (typeof legalDocTypeCodes)[number];

export const legalDocTypeLabels: Record<LegalDocTypeCode, string> = {
  'articles-of-incorporation': 'Articles of Incorporation',
  'w9-form': 'W9 Form',
  'unify-contract': 'Unify Contract',
  'general-liability-umbrella-policy': 'General Liability and Umbrella Policies',
  epli: 'Employment Practices Liability Insurance',
};

export const requiredLegalDocTypes: LegalDocTypeCode[] = [
  'articles-of-incorporation',
  'w9-form',
  'unify-contract',
  'general-liability-umbrella-policy',
];

export const uploadLegalDocSchema = z.object({
  name: z.string().trim().min(1, 'Document name is required'),
  typeCode: z.enum(legalDocTypeCodes, { message: 'Select a document type' }),
  expirationDate: z.string().optional(),
});

export type UploadLegalDocInput = z.infer<typeof uploadLegalDocSchema>;
